import dayjs from 'dayjs'

type time = 'week' | 'month'

/**
 * 获取时间所在时间 开始天 和 末尾天
 */
export const getDateStartEndTime = (date, type: time) => {
  const time = date || new Date()
  const startTime = dayjs(time).startOf(type).format('YYYY-MM-DD')
  const endTime = dayjs(time).endOf(type).format('YYYY-MM-DD')
  return {
    startTime,
    endTime
  }
}

/**
 * 格式化时间
 */
export const getDays = (date?, format?) => {
  const defaultValue = '-'
  if (date && date !== defaultValue) {
    return dayjs(date).format(format || 'YYYY-MM-DD HH:mm:ss')
  } else {
    return defaultValue
  }
}
